module.exports = __webpack_public_path__ + "static/media/order-image.7998f103.svg";